import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Paper, Stack, Typography, Button } from "@mui/material";
import { LABELS, VERTICAL_BY_ID } from "../verticals/registry";
import {
  buildHttpsUrl,
  getPublicHostForVertical,
  shouldCrossDomainNavigate,
} from "../util/brandDomains";

export default function VerticalLanding({ id }) {
  const nav = useNavigate();
  const v = VERTICAL_BY_ID[id] ?? VERTICAL_BY_ID.care;
  const labels = LABELS[v.id];
  const isCare = v.id === "care";
  const basePath = isCare ? "/care/find" : `/${v.routeBase}`;

  const navigateForVertical = (targetId, fallbackPath) => {
    const targetHost = getPublicHostForVertical(targetId);
    if (shouldCrossDomainNavigate(targetHost)) {
      window.location.assign(buildHttpsUrl(targetHost, "/"));
      return;
    }
    nav(fallbackPath);
  };

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Paper
        sx={{
          p: { xs: 3, md: 4 },
          borderRadius: 4,
          border: "1px solid",
          borderColor: "divider",
          background: isCare
            ? "linear-gradient(180deg, #eff6ff 0%, #ffffff 40%)"
            : "linear-gradient(180deg, #f5f3ff 0%, #ffffff 40%)",
        }}
      >
        <Stack spacing={1.5}>
          <Typography variant="overline" color="text.secondary">
            {isCare ? "Care Product" : "Booking Product"}
          </Typography>

          <Typography variant="h4" fontWeight={800}>
            {isCare
              ? "Care operations built for modern care providers"
              : "Standalone scheduling built for service businesses"}
          </Typography>

          <Typography variant="body1" color="text.secondary">
            {isCare
              ? "Browse public care listings or manage care operations from the care workspace."
              : "Run event types, availability, booking links, reminders, and payment-ready scheduling in a focused booking workspace."}
          </Typography>

          <Typography variant="body2">
            {labels.appTitle} has its own language, routes, and entry points so each product feels focused from the first click.
          </Typography>

          <Stack direction="row" spacing={1} sx={{ mt: 2, flexWrap: "wrap" }}>
            <Button
              variant="contained"
              onClick={() => navigateForVertical(v.id, basePath)}
            >
              {isCare ? "Open Care" : "Open Booking"}
            </Button>

          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}
